export default "__VITE_ASSET__CuCXkI14__"